import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { toastsActions } from '@zola-helpers/client';

import { deleteDraft } from 'cards/actions/draftsAndOrdersRedesignActions';
import { deleteProject, handleDeleteProjectError } from '../../../../actions/draftsActions';
import { hideModal } from '../../../../actions/modalActions';

import './DeleteProjectDraftModal.less';

class DeleteProjectDraftModal extends PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      deleteConfirmation: '',
      enableDelete: false,
    };
  }

  handleChange(e) {
    this.setState({
      deleteConfirmation: e.target.value,
      enableDelete: e.target.value === 'delete',
    });
  }

  handleSubmit() {
    const { onDeleteProjectDraft } = this.props;
    const { enableDelete } = this.state;
    if (enableDelete) {
      onDeleteProjectDraft();
    }
  }

  render() {
    const { project, hideModalFn } = this.props;
    const { deleteConfirmation, enableDelete } = this.state;

    return (
      <div className="delete-project-draft">
        <div className="delete-project-draft-hed">
          <h2>Delete draft?</h2>
        </div>
        <div className="delete-project-draft-body">
          <p className="delete-project-draft-dek">
            Deleting the draft of <strong>{project.project_name}</strong> will remove all
            information associated with the draft, including any text, photos, and guest list.
          </p>
          <div className="delete-confirmation-container">
            <p className="delete-confirmation-label">
              Please type <strong>&quot;delete&quot;</strong> below to confirm.
            </p>
            <input
              name="deleteConfirmation"
              value={deleteConfirmation}
              onChange={this.handleChange}
              id="delete-confirmation"
              className="form-control delete-confirmation-input"
            />
          </div>
        </div>
        <div className="delete-project-draft-footer">
          <div className="action-buttons">
            <ButtonV2 onClick={() => hideModalFn()} variant="secondary">
              No, Keep Draft
            </ButtonV2>
            <ButtonV2
              onClick={this.handleSubmit}
              variant={enableDelete ? 'tertiary' : 'primary'}
              disabled={!enableDelete}
            >
              Yes, Delete Draft
            </ButtonV2>
          </div>
        </div>
      </div>
    );
  }
}

DeleteProjectDraftModal.propTypes = {
  project: PropTypes.shape({}),
  onDeleteProjectDraft: PropTypes.func.isRequired,
  hideModalFn: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onDeleteProjectDraft: () => {
    dispatch(deleteProject(ownProps.project.project_uuid))
      // remove draft from new draftsAndOrdersRedesign section of store
      .then(({ payload }) =>
        dispatch(
          deleteDraft(payload.projectUUID, 'PAPER', ownProps.project.primary_customization.type)
        )
      )
      .then(() => dispatch(hideModal()))
      .then(() => dispatch(toastsActions.positive({ headline: 'Draft Deleted!' })))
      .catch(error => dispatch(handleDeleteProjectError(error)));
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DeleteProjectDraftModal);
